import { decodeJWT } from "../../../_utils/jwt";
import { FEATURE_FLAG_BYPASS } from './featureFlags';
import { DEFAULT_FEATURE_FLAGS } from '../config/defaultFeatureFlags';

export { decodeJWT };

/**
 * Extracts feature flags from a JWT token
 * @param {string} token - JWT token string
 * @returns {object} - Feature flags object
 */
export function extractFeatureFlags(token) {
  if (FEATURE_FLAG_BYPASS) {
    return DEFAULT_FEATURE_FLAGS;
  }

  const decoded = decodeJWT(token);

  if (!decoded) {
    console.warn('[Feature Flags] Could not decode token, returning default flags (all enabled)');
    return DEFAULT_FEATURE_FLAGS;
  }

  // Check if token has expired
  if (decoded.exp && Date.now() >= decoded.exp * 1000) {
    console.warn('[Feature Flags] Token has expired, returning default flags (all enabled)');
    return DEFAULT_FEATURE_FLAGS;
  }

  // Return feature flags from token or default if missing
  return decoded.featureFlags || DEFAULT_FEATURE_FLAGS;
}
